export default __webpack_public_path__ + "static/media/project.ccc45711.png";